import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Types
import { UpdateAiTemplateType } from 'Shared/types/UpdateAiTemplate.type';

// Selectors
import { getUpdateAiTemplatesByDefaultTemplate } from 'Shared/selectors/UpdateAiSettings.selectors';

// Actions
import { fetchDefaultTemplates } from 'Shared/actions/UpdateAiSettings.actions';

export const useUpdateAiTemplates = () => {
  const dispatch = useDispatch();

  const [isLoadingTemplates, setIsLoadingTemplates] = useState<boolean>(true);

  const templates: UpdateAiTemplateType[] = useSelector(state =>
    getUpdateAiTemplatesByDefaultTemplate(state, { defaultTemplate: true })
  );

  useEffect(() => {
    if (templates.length === 0) {
      dispatch(fetchDefaultTemplates()).then(() => {
        setIsLoadingTemplates(false);
      });
    } else {
      setIsLoadingTemplates(false);
    }
  }, [templates]);

  return { templates, isLoadingTemplates };
};
